import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/users.json';
import ar from './i18n/ar/users.json';

registerFeatureI18n('adminUsers', { en, ar });

export { UsersPage } from './UsersPage';
